import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  layout: {
    padding: `${theme.spacing(3)} 26px ${theme.spacing(14)}`,
    [theme.breakpoints.down('lg')]: {
      display: 'flex',
      flexDirection: 'column',
      minHeight: 'calc(100vh - 70px - 90px)', // minus header and title
      padding: `0 26px ${theme.spacing(5)}`,
    },
    [theme.breakpoints.down('md')]: {
      minHeight: 'calc(100vh - 54px - 56px)', // minus header and title
      padding: `0 ${theme.spacing(1.5)} ${theme.spacing(1.5)}`,
    },
    [theme.breakpoints.downLandscape('lg')]: {
      ...(theme.isMobileDevice && {
        padding: `0 26px ${theme.spacing(5)}`,
      }),
    },
  },
  orderInfoButton: {
    display: 'none',
    width: 'fit-content',
    marginBottom: theme.spacing(4),
    [theme.breakpoints.down('lg')]: {
      display: 'inline-flex',
    },
    [theme.breakpoints.downLandscape('lg')]: {
      ...(theme.isMobileDevice && {
        display: 'inline-flex',
      }),
    },
  },
}));
